module.exports = __webpack_public_path__ + "static/media/Banking.54340847.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/Banking.png
// module id = 1714
// module chunks = 1